// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__JfxDK","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__2kcaL"};